// eslint-disable-next-line no-restricted-imports
import type { DrawerProps } from '@mui/material';
// eslint-disable-next-line no-restricted-imports
import { Drawer as MuiDrawer } from '@mui/material';

export type { DrawerProps as PersistentDrawerProps };

export const PersistentDrawer = ({ variant = 'persistent', ...props }: DrawerProps) => (
  <MuiDrawer
    variant={variant}
    {...props}
  />
);
